<template>
	<div>
		<page-header image="header4.jpg" title="Stand 2"></page-header>

        <b-container class="container">
            <b-row>
                <wines :items="wines"></wines>
            </b-row>
			<b-row>
				<sweet-wines :items="sweetWines"></sweet-wines>
			</b-row>
            <b-row>
                <alcohol-free :items="alcoholFree"></alcohol-free>
            </b-row>
            <b-row>
                <food :items="food"></food>
            </b-row>
        </b-container>
	</div>
</template>

<script>
// @ is an alias to /src

import PageHeader from '@/components/PageHeader.vue';
import Wines from '@/components/Wines.vue';
import SweetWines from '@/components/SweetWines.vue';
import AlcoholFree from '@/components/AlcoholFree.vue';
import Food from '@/components/Food.vue';

export default {
	name: 'booth2',
	components: {
		PageHeader,
		Wines,
		SweetWines,
        AlcoholFree,
        Food
	},
    data() {
        return {        
            wines: [
                { nr: 1, year: '2021', wine: { wine: 'Trollinger mit Lemberger >TL<', sublabel: 'QbA feinherb' }, sweetness: '13.6', glas_01: '2', glas_025: '4', bottle: '11.5' },
                { nr: 2, year: '2019', wine: { wine: 'Remshalden Spätburgunder', sublabel: 'Spätlese trocken' }, sweetness: '4', glas_01: '3', glas_025: '7', bottle: '19' },
                { nr: 3, year: '2019', wine: { wine: 'Syrah Edition >R<', sublabel: 'QbA trocken' }, sweetness: '0.6', glas_01: '3.5', glas_025: '8', bottle: '22' },
                { nr: 4, year: '2022', wine: { wine: 'Zweigelt Rosé >ZR<', sublabel: 'QbA feinfruchtig' }, sweetness: '17', glas_01: '2', glas_025: '4', bottle: '11.5' },
                { nr: 5, year: '2022', wine: { wine: 'Sweet Meet Cuvée Rosé', sublabel: 'QbA' }, sweetness: '48.2', glas_01: '2.5', glas_025: '5.5', bottle: '15' },
				{ nr: 6, year: '2022', wine: { wine: 'Chardonnay >C<', sublabel: 'QbA trocken' }, sweetness: '2.2', glas_01: '2.5', glas_025: '5.5', bottle: '15' },
                { nr: 7, year: '2022', wine: { wine: 'Gewürztraminer >GT<', sublabel: 'QbA fruchtig' }, sweetness: '26.9', glas_01: '2.5', glas_025: '5.5', bottle: '15' },
                { nr: 8, year: '2022', wine: { wine: 'SchilfSandStein Riesling', sublabel: 'QbA trocken' }, sweetness: '6.5', glas_01: '2.5', glas_025: '5.5', bottle: '15' },
                { nr: 9, year: '2022', wine: { wine: 'Sauvignon Blanc >SB<', sublabel: 'QbA fruchtig' }, sweetness: '13.9', glas_01: '3', glas_025: '7', bottle: '19' },
			],
			sweetWines: [
				{ nr: 10, wine: { wine: 'Fresco 0.0. alkoholfrei', sublabel: '' }, sweetness: '16', glas_01: '2', glas_025: '', bottle: '11.5' },
				{ nr: 11, wine: { wine: '2021 Muskateller Secco Perlwein', sublabel: '' }, sweetness: '23.8', glas_01: '3', glas_025: '', bottle: '19' }
			],
            alcoholFree: [
                { volume: "0,73", content: "Roter Traubensaft", glas_025: 2.5, bottle: 6 },
                { volume: "0,33", content: "Cola / Fanta", glas_025: 0, bottle: 2.5 },
                { volume: "0,5", content: "Apfelsaftschorle", glas_025: 0, bottle: 2.5 },
                { volume: "0,5", content: "Mineralwasser", glas_025: 0, bottle: 2.5 }
            ],
            food: [
                { food: "Peitschenstecken mit Brot", price: 3 },
                { food: "Schinkenwurst mit Brot", price: 3 },
                { food: "Käse mit Brot", price: 3 },
                { food: "Lachscreme-Brot", price: 3 },
                { food: "Salzkuchen (nur Samstag)", price: 2 },
                { food: "Crépes mit Zucker und Zimt (nur Sonntag)", price: 2 },
                { food: "Crépes mit Weingeleé (nur Sonntag)", price: 3 },
                { food: "Crépes mit gerauchtem Schinken u. Käse (nur Sonntag)", price: 4 },
            ]
        }
    }
}
</script>

<style scoped lang="scss">
	
</style>